import styled from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';

export const AppContainer = styled(Div)`
  overflow: hidden;
`;
